import VuetableFieldCheckbox from "@/plugins/vuetable-checkbox/VuetableFieldCheckboxLoad";
import i18n from '@/plugins/i18n';

export default [
    {
        name: VuetableFieldCheckbox,
        title: "Checkbox",
        width: "10px",
        togglable: false,
        dataClass: "vertical-align-top",
        titleClass: "",
        disabled: function (rowData) {
            return false;
        },
    },
    {
        id: 'channel_logo',
        name: 'channel_logo',
        title: i18n.t('Ch.'),
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "image",
        title: i18n.t('Image'),
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "name",
        title: i18n.t('Product Name'),
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "stock_deduction",
        title: i18n.t('Stock Deduction'),
        // title: '<table><tr><td style="width: 90px;">' + i18n.t('Stock Deduction.') + '</td></tr></table>',
        dataClass: "vertical-align-top",
        titleClass: "",
    },
    {
        name: "quantity",
        title: i18n.t('QTY'),
        dataClass: "vertical-align-top",
        titleClass: "text-uppercase",
    },
    {
        name: "status",
        title: i18n.t('Status'),
        width: "120px",
        dataClass: "vertical-align-top",
        titleClass: "",
    }
];



// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/assets/FieldsDefValidateProducts.js